import React from 'react';
import { MobileContainer as Container } from './style';
import { Icon } from '../../Components/Icons/Icons';
import { Text } from '../../UI/Text';
import { OuterMargin } from '../../Layouts';

export const MobileContainer = () => {
    return (
        <Container>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <OuterMargin bottom={'16px'}>
                    <Icon.Box size={'32x32'}>
                        <Icon.SadIcon />
                    </Icon.Box>
                </OuterMargin>
                <Text fontSize={12} weight={100} alignCenter={true}>
                    This page is not available on mobile devices and tablets. Please, use a larger screen device to
                    access it
                </Text>
            </div>
        </Container>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/MobileContainer.js